import { renderAuthoredNarrativeBundle } from './authoredNarrativeRender';

const CHART_ID = 'health_indicators';

export type HealthIndicatorViewId =
  | 'insurance'
  | 'asthma'
  | 'cardiovascular'
  | 'low_birth_weight';

export function buildHealthIndicatorAuthoredBundle(
  view: HealthIndicatorViewId,
  tokens: Record<string, string>
) {
  const bundle = renderAuthoredNarrativeBundle(CHART_ID, view, tokens);
  bundle.methodology = undefined;
  return bundle;
}

export { buildHealthIndicatorTokens, healthChartToViewId } from './peopleHealthNarrativeFacts';
